import React from 'react'
import styles from '../materials.module.scss'
import { Button, Divider, Slider, TextField } from '@material-ui/core'
import { useMutation } from '@apollo/client'
import { Typography } from '@material-ui/core'
import { useState } from 'react'
import { Event } from 'three'
import { useQuery } from '@apollo/client'

import { Q_MATERIAL_TYPE } from 'graphql/query'

import { MC_MATERIAL_TYPE } from 'graphql/mutations'
import Loading from 'components/Global/Loading'

interface propTypes {
  handleClose: () => void
}
interface MatTypes {
  name: string
  roughnesMap: string
  metalness: number
  roughnesIntensity: number
  normalMap: string
  normalIntensity: number
  normalu: number
  normalv: number
  details: string
}

const CreateTypes = ({ handleClose }: propTypes) => {
  const [loading, setLoading] = React.useState<boolean>(false)

  const [matType, setMatType] = useState<string>('')
  const [mtlInt, setMtlInt] = useState<number>(0)
  const [rfInt, setRfInt] = useState<number>(0.3)
  const [rfMap, setRfMap] = useState<File>()
  const [nrmInt, setNrmInt] = useState<number>(1)
  const [nrmU, setNrmU] = useState<number>(10)
  const [nrmV, setNrmV] = useState<number>(10)
  const [nrmMap, setNrmMap] = useState<File>()
  const [detail, setDetail] = useState<string>('')
  const [previews, setPreview] = useState<File[]>([])

  const [mTypes, setMTypes] = React.useState<string[]>([])
  const { refetch } = useQuery(Q_MATERIAL_TYPE)

  const [call] = useMutation(MC_MATERIAL_TYPE)

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    console.log('ajhscv')

    e.preventDefault()
    setLoading(true)
    call({
      variables: {
        name: matType,
        metalness: mtlInt,
        roughness: rfInt,
        roughnessMap: rfMap,
        normalStrength: nrmInt,
        normalSizeU: nrmU,
        normalSizeV: nrmV,
        normalMap: nrmMap,
        detail,
        previews,
      },
    })
      .then(res => {
        handleClose()
      })
      .catch(err => console.error(err))
  }

  React.useEffect(() => {
    refetch() &&
      refetch().then(res => {
        setMTypes(
          res.data.rMaterialType.map((t: { [key: string]: any }) => t.name)
        )
      })
  }, [])
  const checkMatExists = () => {
    return mTypes.includes(matType)
  }

  return loading ? (
    <Loading />
  ) : (
    <form onSubmit={e => onSubmit(e)} className={styles.cSRoot}>
      <TextField
        error={checkMatExists()}
        helperText={
          checkMatExists() ? 'Material Type name already exists' : null
        }
        value={matType}
        onChange={e => {
          setMatType(e.target.value)
        }}
        inputProps={{ maxLength: 40 }}
      />

      <TextField
        label="detail"
        value={detail}
        onChange={e => setDetail(e.target.value)}
        // inputProps={{ maxLength: 40 }}
      />
      <Button id="environment" variant="contained" component="label" fullWidth>
        {previews.length !== 0
          ? previews.map(file => `• ${file.name} `)
          : "select previews 'png'"}
        <input
          type="file"
          accept=".png"
          hidden
          multiple
          onChange={e => {
            if (e.target.files) {
              setPreview(Array.from(e.target.files))
            }
          }}
        />
      </Button>
      <Divider className={styles.margin} />
      <Typography variant="h6" className={styles.margin}>
        Metalness
      </Typography>
      <Typography variant="subtitle2">Metalness Intensity</Typography>
      <Slider
        step={0.025}
        min={0}
        max={1}
        marks
        value={mtlInt}
        onChange={(e: Event) => setMtlInt(e.target.value)}
        valueLabelDisplay="auto"
        color="secondary"
      />
      <Typography variant="h6" className={styles.margin}>
        Roughness
      </Typography>
      <Slider
        step={0.025}
        min={0}
        max={1}
        marks
        value={rfInt}
        onChange={(e: Event) => setRfInt(e.target.value)}
        valueLabelDisplay="auto"
        color="secondary"
      />
      <Typography variant="subtitle2">Roughness Intensity</Typography>

      <Button id="environment" variant="contained" component="label" fullWidth>
        {rfMap ? `${rfMap.name}` : "select roughness map 'png'"}
        <input
          type="file"
          accept=".png"
          hidden
          onChange={e => {
            if (e.target.files) {
              setRfMap(e.target.files[0])
            }
          }}
        />
      </Button>
      <Divider className={styles.margin} />
      <Typography variant="h6" className={styles.margin}>
        Normals
      </Typography>
      <Typography variant="subtitle2">Normals Intensity</Typography>

      <Slider
        step={0.1}
        min={0.1}
        max={2}
        marks
        value={nrmInt}
        onChange={(e: Event) => setNrmInt(e.target.value)}
        valueLabelDisplay="auto"
        color="secondary"
      />
      <Button id="environment" variant="contained" component="label" fullWidth>
        {nrmMap ? `${nrmMap.name}` : "select normal map 'png'"}
        <input
          type="file"
          accept=".png"
          hidden
          onChange={e => {
            if (e.target.files) {
              setNrmMap(e.target.files[0])
            }
          }}
        />
      </Button>
      <div className={styles.cSSection}>
        <div style={{ width: '50%', margin: '.5rem' }}>
          <Typography style={{ width: '5vw' }} variant="subtitle2">
            Normal U
          </Typography>
          <Slider
            step={0.1}
            min={1}
            max={20}
            marks
            valueLabelDisplay="auto"
            value={nrmU}
            onChange={(e: Event) => setNrmU(e.target.value)}
            color="secondary"
          />
        </div>
        <div style={{ width: '50%', margin: '.5rem' }}>
          <Typography style={{ width: '5vw' }} variant="subtitle2">
            Normal V
          </Typography>
          <Slider
            step={0.1}
            min={1}
            max={20}
            marks
            valueLabelDisplay="auto"
            value={nrmV}
            onChange={(e: Event) => setNrmV(e.target.value)}
            color="secondary"
          />
        </div>
      </div>
      <Button
        type="submit"
        variant="contained"
        color="secondary"
        disabled={checkMatExists()}
      >
        Submit
      </Button>
    </form>
  )
}

export default CreateTypes
